import React from 'react';
import { Link } from 'react-router-dom';
import HamburgerMenu from './HamburgerMenu';
import StrutWaterfallPage from './StrutWaterfallPage';

function StrutWaterfallReportPage({ theme }) {
    const isDark = theme === 'dark';
    const linkColor = isDark ? '#6cb2f7' : '#007bff';
    const bg = isDark ? '#121212' : '#f4f7f6';

    return (
        <div style={{ backgroundColor: bg, minHeight: '100vh', padding: '20px' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
                flexWrap: 'wrap',
                gap: '10px',
            }}>
                <HamburgerMenu theme={theme} />
                <Link to="/reports" style={{ color: linkColor, textDecoration: 'none', fontSize: '16px' }}>
                    &larr; Back to Reports
                </Link>
            </div>
            <StrutWaterfallPage theme={theme} embedded />
        </div>
    );
}

export default StrutWaterfallReportPage;
